import React, { Component } from 'react'
import Img from 'gatsby-image'


class TeamPage extends Component {

  constructor(props)
  {
    super(props)
    this.screenshotLookup = {}; 
    for(var screenshotfile of this.props.data.allFile.edges)
    {
      this.screenshotLookup[screenshotfile.node.relativePath] = screenshotfile.node.childImageSharp
    }


    this.getImage = this.getImage.bind(this)
  }

  getImage(firstName)
  {
    const lookup = `${firstName.toLowerCase()}.jpg`
    
    try {
      return <Img sizes={this.screenshotLookup[lookup].sizes} />
    } catch (e) {
      return <Img sizes={this.screenshotLookup["ghostie.jpg"].sizes} />
    }
  }
  

  renderPerson(person) {
    return (
      <div key={person.id} className="col-4 col-6-narrow col-12-mobilep">
        <a href="#" className="image fit">
          {this.getImage(person.firstName)}
          {/* <img src={getImage(person.firstName)} alt="" /> */}
        </a>
        <h3>
          {person.firstName} {person.lastName}
        </h3>
        <h4>{person.role}</h4>
        <div
          dangerouslySetInnerHTML={{ __html: person.info }}
          className="content"
        />
      </div>
    )
  }

  render() {
    const people = this.props.data.allAboutInfo.edges
    return (
      <section className="main" className="wrapper style2 team">
        <header className="major">
          <h2>Our team</h2>
          <p>Meet the people behind the ghosts</p>
        </header>
        <div className="container">
          <section>
            <div className="row">
              {people.map(edge => this.renderPerson(edge.node))}
            </div>
          </section>
        </div>
      </section>
    )
  }
}

export default TeamPage

export const imageQueryAndTeamQuery = graphql`
  query TeamQuery {
    allAboutInfo(
      sort: {fields: [type, firstName]}
    ) {
      edges {
        node {
          id
          firstName
          lastName
          role
          info
          type
        }
      }
    }
    allFile(sort: {fields: [relativePath], order: ASC}
  )
    {
      edges {
        node {
          relativePath
          childImageSharp
          {
                sizes(maxWidth: 500 ) {
                  ...GatsbyImageSharpSizes
                }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/team.js